import React, {useState} from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/styles'
import {TextField} from "mui-rff"
import FormLabel from "../../FormLabel"
import {If, Then, Else} from "react-if"
import MaskedInput from 'react-text-mask'
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import Input from "@material-ui/core/Input"
import {Typography} from "@material-ui/core"

const useStyles = makeStyles(() => ({
  field: {}
}))

const FormDisplay = ({field, title, required, text}) => {
  const classes = useStyles()

  return (
    <>
      <FormLabel title={title} isFilter={true}/>
      <Typography variant="subtitle2">{text}</Typography>
    </>
  )
}

export default FormDisplay
